export default "__VITE_ASSET__BR7jRf1d__"